import { paymentStore } from './model';
import { SET_PAYMENT_METHODS, SET_PUB_KEY, SET_SEPA_DATA } from './constants';

export function paymentReducer(state = paymentStore, action) {
    switch (action.type) {
        case SET_PAYMENT_METHODS:
            return {
                ...state,
                paymentMethods: action.payload,
            };

        case SET_PUB_KEY:
            return {
                ...state,
                card: {
                    pubKey: action.payload,
                },
            };

        case SET_SEPA_DATA:
            return {
                ...state,
                sepa: {
                    ...state.sepa,
                    ...action.payload,
                },
            };
        default:
            return state;
    }
}
